import { render } from "./CommonError.vue?vue&type=template&id=4458c116&scoped=true&ts=true"
import script from "./CommonError.vue?vue&type=script&lang=ts"
export * from "./CommonError.vue?vue&type=script&lang=ts"

import "./CommonError.vue?vue&type=style&index=0&id=4458c116&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4458c116"]])

export default __exports__